import { typo as defaultTypo } from 'themes/default/typo';
import { ICssTheme } from 'themes/types';

export const typo: ICssTheme['typo'] = defaultTypo;
